import * as React from 'react';
import { Toaster as SonnerToaster, toast } from 'sonner';

/**
 * Toasts, themed to our tokens. Mount <Toaster /> once at the app root and call
 * `toast.success(...)` / `toast.error(...)` from anywhere.
 *
 * Error toasts must be given the normalised message from api-client, never a
 * raw error object. See CLAUDE.md convention 6.
 */
function Toaster(props) {
  return (
    <SonnerToaster
      position="bottom-right"
      duration={4000}
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group rounded-lg border-hairline border-border bg-card text-card-foreground shadow-raised text-meta',
          title: 'font-medium text-foreground',
          description: 'text-muted-foreground',
          actionButton: 'bg-primary text-primary-foreground',
          cancelButton: 'bg-secondary text-secondary-foreground',
          success: 'border-success/30',
          warning: 'border-warning/30',
          error: 'border-destructive/30',
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast };
